import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {take} from 'rxjs/operators';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogModel} from '@shared/models/dialog.model';
import {Injectable} from '@angular/core';
import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';

@Injectable({
  providedIn: 'root',
})
export class StartWorkFlowCommandHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
  constructor( public commandService: CommandService,
               public router: Router,
               private dialogService: DialogService,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService, ) {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    if (command.fieldValues['FlowExecutionId'] && !command.fieldValues['SkipPrepareLunch']) {
      const prepareLaunchCommand = new PlatformCommand('PrepareLaunchCommand', 'FlowApi');
      prepareLaunchCommand.fieldValues['FlowId'] = command.fieldValues['FlowExecutionId'];
      handler.executeCommand(prepareLaunchCommand);
      return true;
    }
    const fieldKey = command.fieldValues['FieldKey'];
    if (command.fieldValues[fieldKey]) {
      const workflowInfo = command.fieldValues[fieldKey];
      if (workflowInfo.status && workflowInfo.status.length) {
        const workflowCommand = new PlatformCommand('NavigateToWorkflowCommand', 'FlowApi');
        workflowCommand.fieldValues['FlowId'] = workflowInfo.executionId;
        this.executeCommandToApi(workflowCommand, handler);
        return true;
      } else {
        const workflowCommand = new PlatformCommand('NavigateToWorkflowCommand', 'FlowApi');
        workflowCommand.fieldValues['FlowId'] = workflowInfo.templateId;
        this.executeCommandToApi(workflowCommand, handler);
        return true;
      }
    }
    const dialogModel: DialogModel = DialogModel.create('Start Workflow',
      'StartWorkflowDialogComponent',
      {},
      '600px',
      '700px');
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        const flowTemplateId = res.data.input['flowTemplateId'];
        // const reference = res.data.input['reference'];
        command.fieldValues['FlowTemplateId'] = flowTemplateId;
        // command.fieldValues['Reference'] = reference;
        this.executeCommandToApi(command, handler);
      }
    });
    return true;
  }
  protected executeCommandToApi(command: PlatformCommand, handler: IPlatformToolHandler) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[PlatformFilterHandler] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            handler.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
            return;
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (handler && handler.invalidateSubject) {
            handler.invalidateSubject.invalidate();
          }
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }
}

